import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from './homepage/HomePage';
import NotFoundPage from './error/NotFoundPage';
import ForbiddenPage from './error/ForbiddenPage';
import InternalErrorPage from './error/InternalErrorPage';
import InvitationAcceptancePage from './invitation/InvitationAcceptancePage';
import InvitationActivation from './invitation/InvitationActivationPage';
import PersonalizationCompletionSuccessPage from './personalization/PersonalizationCompletionSuccessPage';
import PersonalizationStartDeepLinkPage from './personalization/PersonalizationStartDeepLinkPage';

const BASE_PATH = '/';
const FORBIDDEN_PATH = `${BASE_PATH}zugriff-verweigert`;
export const INTERNAL_ERROR_PATH = `${BASE_PATH}interner-fehler`;
export const ACCEPT_INVITATION = `${BASE_PATH}mitglied/:teamMemberId/einladung/:invitationId/aktivieren`;
const INVITATION_SUCCESS = `${BASE_PATH}mitglied/:teamMemberId/einladung/:invitationId/erfolg`;
const PERSONALIZATION_COMPLETION_SUCCES = `${BASE_PATH}personalisierung/erfolg`;
const PERSONALIZATION_START_DEEP_LINK = `${BASE_PATH}personalisierung/start`;
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={BASE_PATH} element={<HomePage />} />
      <Route path={FORBIDDEN_PATH} element={<ForbiddenPage />} />
      <Route path={INTERNAL_ERROR_PATH} element={<InternalErrorPage />} />
      <Route path={ACCEPT_INVITATION} element={<InvitationAcceptancePage />} />
      <Route path={INVITATION_SUCCESS} element={<InvitationActivation />} />
      <Route path={PERSONALIZATION_COMPLETION_SUCCES} element={<PersonalizationCompletionSuccessPage />} />
      <Route path={PERSONALIZATION_START_DEEP_LINK} element={<PersonalizationStartDeepLinkPage />} />
      <Route element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
